import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const gexTrendStrengthGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX_GEX_Trend_Strength',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX_GEX_Trend_Strength@tv-basicstudies-1",
        description: "SPX GEX Trend Strength",
        shortDescription: "SPX GTS",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },

        // Keep original plots first
        plots: [
          { id: "call_strength", type: "line", title: "Call Trend", trackPrice: false, transparency: 0,  fillGaps: true },
          { id: "put_strength",  type: "line", title: "Put Trend",  trackPrice: false, transparency: 100, fillGaps: true },

          // Background band boundaries (constants; hidden)
          { id: "z020_top", type: "line", title: "Top 0.20", trackPrice: false },
          { id: "z000_bot", type: "line", title: "Bot 0.00", trackPrice: false },
          { id: "z030_top", type: "line", title: "Top 0.30", trackPrice: false },
          { id: "z020_bot", type: "line", title: "Bot 0.20", trackPrice: false },
          { id: "z040_top", type: "line", title: "Top 0.40", trackPrice: false },
          { id: "z030_bot", type: "line", title: "Bot 0.30", trackPrice: false },
          { id: "z050_top", type: "line", title: "Top 0.50", trackPrice: false },
          { id: "z040_bot", type: "line", title: "Bot 0.40", trackPrice: false },
          { id: "z060_top", type: "line", title: "Top 0.60", trackPrice: false },
          { id: "z050_bot", type: "line", title: "Bot 0.50", trackPrice: false },
          { id: "z070_top", type: "line", title: "Top 0.70", trackPrice: false },
          { id: "z060_bot", type: "line", title: "Bot 0.60", trackPrice: false },
        ],

        // Full-width background strips (top vs bottom)
        filledAreas: [
          { id: "bg_020", objAId: "z020_top", objBId: "z000_bot", type: "plot_plot", title: "0.00–0.20", fillToIntersection: true },
          { id: "bg_030", objAId: "z030_top", objBId: "z020_bot", type: "plot_plot", title: "0.20–0.30", fillToIntersection: true },
          { id: "bg_040", objAId: "z040_top", objBId: "z030_bot", type: "plot_plot", title: "0.30–0.40", fillToIntersection: true },
          { id: "bg_050", objAId: "z050_top", objBId: "z040_bot", type: "plot_plot", title: "0.40–0.50", fillToIntersection: true },
          { id: "bg_060", objAId: "z060_top", objBId: "z050_bot", type: "plot_plot", title: "0.50–0.60", fillToIntersection: true },
          { id: "bg_070", objAId: "z070_top", objBId: "z060_bot", type: "plot_plot", title: "0.60–0.70", fillToIntersection: true },
        ],

        defaults: {
          styles: {
            // Main line visible
            call_strength: {
              linestyle: 0, linewidth: 1, plottype: 0, trackPrice: false,
              transparency: 0, visible: true, color: "#ffffff", joinPoints: true
            },
            // Secondary hidden
            put_strength:  {
              linestyle: 0, linewidth: 2, plottype: 0, trackPrice: false,
              transparency: 100, visible: false, color: "#ff3b3b", joinPoints: true
            },

            // Hide boundary helper lines completely; fills use them
            z020_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z000_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z030_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z020_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z040_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z030_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z050_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z040_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z060_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z050_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z070_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
            z060_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
          },

          // Band colors
          filledAreasStyle: {
            bg_020: { color: "#292f56", transparency: 70, visible: true },
            bg_030: { color: "#513b6f", transparency: 70, visible: true },
            bg_040: { color: "#7e4580", transparency: 70, visible: true },
            bg_050: { color: "#ac4e86", transparency: 70, visible: true },
            bg_060: { color: "#d75b83", transparency: 70, visible: true },
            bg_070: { color: "#fa7077", transparency: 70, visible: true },
          },

          precision: 2,
          inputs: {}
        },

        // Keep axis/legend clean
        styles: {
          call_strength: { title: "GTS", histogramBase: 0 },
          put_strength:  { title: "GTS (Alt)", histogramBase: 0 },

          z020_top: { title: "Top 0.20", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z000_bot: { title: "Bot 0.00", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z030_top: { title: "Top 0.30", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z020_bot: { title: "Bot 0.20", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z040_top: { title: "Top 0.40", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z030_bot: { title: "Bot 0.30", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z050_top: { title: "Top 0.50", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z040_bot: { title: "Bot 0.40", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z060_top: { title: "Top 0.60", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z050_bot: { title: "Bot 0.50", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z070_top: { title: "Top 0.70", showAxisLabel: false, showLegendValues: false, showLastValue: false },
          z060_bot: { title: "Bot 0.60", showAxisLabel: false, showLegendValues: false, showLastValue: false },
        },

        inputs: []
      },

      constructor: function () {
        this.init = function (ctx) { this._context = ctx; };

        this.main = function (ctx) {
          // Return order:
          // [call_strength, put_strength,
          //  z020_top, z000_bot, z030_top, z020_bot, z040_top, z030_bot,
          //  z050_top, z040_bot, z060_top, z050_bot, z070_top, z060_bot]

          const Z000 = 0.00, Z020 = 0.20, Z030 = 0.30, Z040 = 0.40, Z050 = 0.50, Z060 = 0.60, Z070 = 0.70;

          let line1 = NaN, line2 = NaN;

          try {
            const { gexTrendStrength } = useGreeksWebsocketDataStore.getState();
            const series = gexTrendStrength?.spx;
            if (series?.length) {
              const t = ctx.symbol.time;
              let best = null, md = Infinity;
              for (const p of series) {
                const d = Math.abs(p.timestamp - t);
                if (d < md) { md = d; best = p; }
              }
              if (best && Number.isFinite(+best.value)) {
                line1 = +best.value; // your GTS line on "call_strength"
                line2 = NaN;         // keep secondary hidden
              }
            }
          } catch (e) {
            console.error('[SPX_GEX_Trend_Strength bands] main error:', e);
          }

          // IMPORTANT: no NaNs on latest bar for band lines -> shading updates live
          return [
            line1, line2,
            Z020, Z000,
            Z030, Z020,
            Z040, Z030,
            Z050, Z040,
            Z060, Z050,
            Z070, Z060
          ];
        };
      }
    }
  ]);
};







// import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';
//
// export const gexTrendStrengthGetter = function (PineJS) {
//   return Promise.resolve([
//     {
//       name: 'SPX_GEX_Trend_Strength',
//       metainfo: {
//         metainfoVersion: 53,
//         id: "SPX_GEX_Trend_Strength@tv-basicstudies-1",
//         description: "SPX GEX Trend Strength",
//         shortDescription: "SPX GTS",
//         linkedToSeries: true,
//         is_price_study: false,
//         format: { type: "price" },
//
//         // Keep your originals first
//         plots: [
//           { id: "call_strength", type: "line", title: "Call Trend", trackPrice: false, transparency: 0,  fillGaps: true },
//           { id: "put_strength",  type: "line", title: "Put Trend",  trackPrice: false, transparency: 100, fillGaps: true },
//
//           // ----- Background band boundaries (constants; hidden) -----
//           // 0.00–0.20 (first/wide band)
//           { id: "z020_top", type: "line", title: "Top 0.20" },
//           { id: "z000_bot", type: "line", title: "Bot 0.00" },
//
//           // 0.20–0.30
//           { id: "z030_top", type: "line", title: "Top 0.30" },
//           { id: "z020_bot", type: "line", title: "Bot 0.20" },
//
//           // 0.30–0.40
//           { id: "z040_top", type: "line", title: "Top 0.40" },
//           { id: "z030_bot", type: "line", title: "Bot 0.30" },
//
//           // 0.40–0.50
//           { id: "z050_top", type: "line", title: "Top 0.50" },
//           { id: "z040_bot", type: "line", title: "Bot 0.40" },
//
//           // 0.50–0.60
//           { id: "z060_top", type: "line", title: "Top 0.60" },
//           { id: "z050_bot", type: "line", title: "Bot 0.50" },
//
//           // 0.60–0.70
//           { id: "z070_top", type: "line", title: "Top 0.70" },
//           { id: "z060_bot", type: "line", title: "Bot 0.60" },
//         ],
//
//         // Full-width background strips (top vs bottom)
//         filledAreas: [
//           { id: "bg_020", objAId: "z020_top", objBId: "z000_bot", type: "plot_plot", title: "0.00–0.20", fillToIntersection: true },
//           { id: "bg_030", objAId: "z030_top", objBId: "z020_bot", type: "plot_plot", title: "0.20–0.30", fillToIntersection: true },
//           { id: "bg_040", objAId: "z040_top", objBId: "z030_bot", type: "plot_plot", title: "0.30–0.40", fillToIntersection: true },
//           { id: "bg_050", objAId: "z050_top", objBId: "z040_bot", type: "plot_plot", title: "0.40–0.50", fillToIntersection: true },
//           { id: "bg_060", objAId: "z060_top", objBId: "z050_bot", type: "plot_plot", title: "0.50–0.60", fillToIntersection: true },
//           { id: "bg_070", objAId: "z070_top", objBId: "z060_bot", type: "plot_plot", title: "0.60–0.70", fillToIntersection: true },
//         ],
//
//         defaults: {
//           styles: {
//             // Your line (primary visible)
//             call_strength: {
//               linestyle: 0, linewidth: 2, plottype: 0, trackPrice: false,
//               transparency: 0, visible: true, color: "#ffffff", joinPoints: true
//             },
//             // Secondary hidden
//             put_strength:  {
//               linestyle: 0, linewidth: 2, plottype: 0, trackPrice: false,
//               transparency: 100, visible: false, color: "#ff3b3b", joinPoints: true
//             },
//
//             // Hide boundary helper lines completely (no axis ticks, no legend)
//             z020_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z000_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z030_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z020_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z040_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z030_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z050_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z040_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z060_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z050_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z070_top: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//             z060_bot: { linestyle: 0, linewidth: 0, plottype: 7, transparency: 100, visible: false, color: "#000" },
//           },
//
//           // Light, alternating bands (tweak to taste)
//           filledAreasStyle: {
//             bg_020: { color: "#292f56", transparency: 70, visible: true }, // 0.00–0.20
//             bg_030: { color: "#513b6f", transparency: 70, visible: true }, // 0.20–0.30
//             bg_040: { color: "#7e4580", transparency: 70, visible: true }, // 0.30–0.40
//             bg_050: { color: "#ac4e86", transparency: 70, visible: true }, // 0.40–0.50
//             bg_060: { color: "#d75b83", transparency: 70, visible: true }, // 0.50–0.60
//             bg_070: { color: "#fa7077", transparency: 70, visible: true }, // 0.60–0.70
//           },
//
//           precision: 2,
//           inputs: {}
//         },
//
//         // Explicitly disable axis labels for the band plots
//         styles: {
//           call_strength: { title: "GTS", histogramBase: 0 },
//           put_strength:  { title: "GTS (Alt)", histogramBase: 0 },
//
//           z020_top: { title: "Top 0.20", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z000_bot: { title: "Bot 0.00", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z030_top: { title: "Top 0.30", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z020_bot: { title: "Bot 0.20", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z040_top: { title: "Top 0.40", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z030_bot: { title: "Bot 0.30", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z050_top: { title: "Top 0.50", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z040_bot: { title: "Bot 0.40", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z060_top: { title: "Top 0.60", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z050_bot: { title: "Bot 0.50", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z070_top: { title: "Top 0.70", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//           z060_bot: { title: "Bot 0.60", showAxisLabel: false, showLegendValues: false, showLastValue: false },
//         },
//
//         inputs: []
//       },
//
//       constructor: function () {
//         this.init = function (ctx) { this._context = ctx; };
//
//         this.main = function (ctx) {
//           // Return order:
//           // [call_strength, put_strength,
//           //  z020_top, z000_bot, z030_top, z020_bot, z040_top, z030_bot,
//           //  z050_top, z040_bot, z060_top, z050_bot, z070_top, z060_bot]
//
//           const Z000 = 0.00, Z020 = 0.20, Z030 = 0.30, Z040 = 0.40, Z050 = 0.50, Z060 = 0.60, Z070 = 0.70;
//
//           let line1 = NaN, line2 = NaN;
//           let t = ctx.symbol.time;
//           let latest = null;
//
//           try {
//             const { gexTrendStrength } = useGreeksWebsocketDataStore.getState();
//             const series = gexTrendStrength?.spx;
//             if (series?.length) {
//               // nearest for the line
//               let best = null, md = Infinity;
//               for (const p of series) {
//                 const d = Math.abs(p.timestamp - t);
//                 if (d < md) { md = d; best = p; }
//               }
//               if (best && Number.isFinite(+best.value)) line1 = +best.value;
//
//               // compute last timestamp to suppress last-value labels
//               for (const p of series) if (latest === null || p.timestamp > latest) latest = p.timestamp;
//             }
//           } catch (e) {
//             console.error('[SPX_GEX_Trend_Strength bands 0.10] main error:', e);
//           }
//
//           // --- Last-bar NaN trick: kills right-axis & legend labels for bands ---
//           const isLast = (latest != null && Math.abs(t - latest) < 1e-6);
//           const V = v => (isLast ? NaN : v);
//
//           return [
//             line1, line2,
//             V(Z020), V(Z000),
//             V(Z030), V(Z020),
//             V(Z040), V(Z030),
//             V(Z050), V(Z040),
//             V(Z060), V(Z050),
//             V(Z070), V(Z060)
//           ];
//         };
//       }
//     }
//   ]);
// };
















